import { useState, useEffect } from "react";
import { cn } from "@/lib/utils";

function AnimateSteps({ plan }) {
  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const [showStep, setShowStep] = useState(false);

  useEffect(() => {
    if (!plan || plan.length === 0) {
      return;
    }

    setCurrentStepIndex(0);
    setShowStep(true);

    const stepDuration = 3500; // Show each step for 3.5 seconds
    const totalSteps = plan.length;
    let stepIndex = 0;

    const timer = setInterval(() => {
      // Fade out current step
      setShowStep(false);

      setTimeout(() => {
        stepIndex++;
        if (stepIndex < totalSteps) {
          setCurrentStepIndex(stepIndex);
          setShowStep(true);
        } else {
          // Reset to first step and continue looping indefinitely
          stepIndex = 0;
          setCurrentStepIndex(0);
          setShowStep(true);
        }
      }, 300); // Brief pause between steps
    }, stepDuration);

    // Clean up on unmount or when animation stops
    return () => {
      clearInterval(timer);
    };
  }, [plan]);
  const currentStep = plan?.[currentStepIndex];
  if (!currentStep) return null;
  return (
    <div
      className={cn(
        "transition-all duration-500 ease-in-out p-4 rounded-lg bg-muted/30 min-h-[100px] flex items-center",
        showStep ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2"
      )}
    >
      <div className="w-full">
        {currentStep?.title && (
          <div className="flex items-start gap-2">
            <span className="text-base mt-0.5">•</span>
            <p className="text-base leading-relaxed">{currentStep?.title}</p>
          </div>
        )}
        {currentStep?.sub_request && (
          <p className="text-sm text-muted-foreground mt-2 ml-5">
            <span className="font-medium">Theme:</span> {currentStep?.sub_request}
          </p>
        )}
      </div>
    </div>
  );
}

function ReportPlan({ plan, message, progress }) {
  return (
    <div className="w-full space-y-4">
      <h3 className="text-lg font-semibold">{message || "Building Report Plan..."}</h3>
      <AnimateSteps plan={plan} />
      <div className="w-full">
        <div className="h-1.5 bg-muted rounded-full overflow-hidden">
          <div
            className="h-full bg-primary rounded-full transition-all duration-1000 ease-out"
            style={{ width: `${(progress || 0) * 100}%` }}
          />
        </div>
      </div>
    </div>
  );
}

export default ReportPlan;
